// imports
import React from 'react';
import { useDisclosure } from '@withjoy/joykit';

// local imports
import CurrencySelectorModal, { CurrencySelectorTrigger } from './CurrencySelectorModal';

// interfaces
interface CurrencySelectorProps {
  readonly isEnabled: boolean;
}

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({ isEnabled }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!isEnabled) {
    return null;
  }

  const handleTriggerClick = () => {
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  return (
    <CurrencySelectorModal
      isOpen={isOpen}
      onClose={onClose}
      trigger={
        <CurrencySelectorTrigger
          isOpen={isOpen}
          onClick={handleTriggerClick}
        />
      }
    />
  );
};
